import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { HomeIcon, UserPlusIcon } from "@heroicons/react/24/outline";
import api from "../utils/api";
import InvestorForm from "../components/InvestorForm";

function InvestorFormPage() {
  const navigate = useNavigate();

  const handleSubmit = async (formData) => {
    await api.post("/api/investors", formData);
  };

  const handleCancel = () => {
    navigate("/dashboard");
  };

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        {/* Enhanced Navigation Header */}
        <div className="mb-8">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <Link
                to="/dashboard"
                className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
              >
                <HomeIcon className="h-4 w-4 mr-2" />
                Back to Dashboard
              </Link>
              <div className="flex items-center space-x-2 text-sm text-gray-500">
                <span>•</span>
                <span>Investor Management</span>
                <span>•</span>
                <span>Add New Record</span>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <div className="bg-green-50 px-3 py-1 rounded-full">
                <span className="text-sm font-medium text-green-700">
                  Create New Investor
                </span>
              </div>
            </div>
          </div>

          {/* Page Title and Description */}
          <div className="mt-4">
            <div className="flex items-center gap-3 mb-2">
              <UserPlusIcon className="h-8 w-8 text-gray-700" />
              <h1 className="text-3xl font-bold text-gray-900">
                Add New Investor
              </h1>
            </div>
            <p className="text-gray-600 max-w-3xl">
              Create a new investor record with complete details including
              personal information, investment schemes, and contract stacking
              preferences.
            </p>
          </div>
        </div>

        {/* Reusable Form Component */}
        <InvestorForm
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          submitButtonText="Add Investor"
          title="Add New Investor"
        />
      </div>
    </div>
  );
}

export default InvestorFormPage;
